import { Link } from 'react-router-dom';
import './Home.css';
//import GainersLosers from '../components/GainersLosers';
//import MarketDashboard from '../components/MarketDashboard';
import Marketwidgets from '../components/Marketwidgets';

const AXIS_OPEN_ACCOUNT_URL = 'https://digitalaccount.axisdirect.in/register?Segment=1&SLB=Y&LGCode=BANEHAKUMARI&productId=89&utm_campaign=Assisted%20link&utm_device=Android&affiliate_name=Business%20Associate';

function Home() {
  return (
    <div className="home">

      {/* HERO */}
      <section className="hero">
        <div className="hero-inner">

          <h1>Master the Markets with<br /><span>Wisdom & Strategy</span></h1>
          <div className="hero-badge">Learn · Trade · Invest</div>
          <p className="hero-sub">Guided by Himanshu Kumar — NISM & IRDAI Certified Market Educator</p>

          <div className="hero-btns">
            <a
              href={AXIS_OPEN_ACCOUNT_URL}
              className="btn-gold"
              target="_blank"
              rel="noopener noreferrer"
            >
              Open Demat Account
            </a>
            <Link to="/courses" className="btn-ghost">Explore Courses</Link>
            <Link to="/contact" className="btn-ghost">Get Free Demo</Link>
          </div>

          <div className="hero-stats">
            <div className="stat">
              <div className="stat-num">100+</div>
              <div className="stat-label">People Mentored</div>
            </div>
            <div className="stat-divider"></div>
            <div className="stat">
              <div className="stat-num">SEBI</div>
              <div className="stat-label">Regulated Curriculum</div>
            </div>
            <div className="stat-divider"></div>
            <div className="stat">
              <div className="stat-num">NISM</div>
              <div className="stat-label">Certified Educator</div>
            </div>
            <div className="stat-divider"></div>
            <div className="stat">
              <div className="stat-num">IRDAI</div>
              <div className="stat-label">Certified Advisor</div>
            </div>
            <div className="stat-divider"></div>
            <div className="stat">
              <div className="stat-num">5 Yrs</div>
              <div className="stat-label">Market Experience</div>
            </div>
          </div>

        </div>
      </section>
      
      {/* MARKET WIDGETS — ADD HERE */}
      <Marketwidgets />

      {/* AXIS SECURITIES FRANCHISE */}
      <section className="axis-band">
        <div className="axis-inner">
          <div className="axis-copy">
            <div className="section-tag">Axis Securities Franchise</div>
            <h2 className="section-title">Open a Demat &amp; Trading Account</h2>
            <p className="axis-desc">
              Learn with us, then trade and invest through our Axis Securities franchise.
              Open a Demat and trading account online with Axis Direct.
            </p>
            <a
              href={AXIS_OPEN_ACCOUNT_URL}
              className="btn-gold"
              target="_blank"
              rel="noopener noreferrer"
            >
              Open Account on Axis Direct
            </a>
            <p className="axis-note">
              Broking and depository services are provided by Axis Securities Limited.
              The Atharva Veda Equity is an authorized franchise partner.
              Investments in the securities market are subject to market risks. Read all related documents carefully.
            </p>
          </div>
        </div>
      </section>

      {/* WHAT WE OFFER */}
      <section className="section">
        <div className="section-inner">
          <div className="section-tag">What we offer</div>
          <h2 className="section-title">Everything you need to grow</h2>
          <p className="section-sub">From basics to advanced — all in one place</p>
          <div className="cards-grid">
            <div className="card">
              <div className="card-num">01</div>
              <h3 className="card-title">Learn</h3>
              <p className="card-desc">Structured courses from stock market basics to advanced derivatives. Taught in Hindi & English with real market examples.</p>
              <Link to="/courses" className="card-link">View Courses →</Link>
            </div>
            <div className="card">
              <div className="card-num">02</div>
              <h3 className="card-title">Trade</h3>
              <p className="card-desc">Live trading sessions, chart analysis, technical setups and intraday strategies. Learn to read the market confidently.</p>
              <Link to="/courses" className="card-link">View Courses →</Link>
            </div>
            <div className="card">
              <div className="card-num">03</div>
              <h3 className="card-title">Invest</h3>
              <p className="card-desc">Long-term wealth creation through fundamental analysis, portfolio building and equity investing guided by SEBI principles.</p>
              <Link to="/courses" className="card-link">View Courses →</Link>
            </div>
          </div>
        </div>
      </section>



      {/* FOUNDER */}
      <section className="section founder-section">
        <div className="section-inner founder-inner">
          <div className="founder-left">
            <div className="section-tag">Our Founder</div>
            <h2 className="section-title">Himanshu Kumar</h2>
            <p className="founder-role">Founder · Market Educator · NISM Certified · IRDAI Certified</p>
            <div className="gold-divider"></div>
            <p className="founder-bio">With over 5 years of hands-on trading and teaching experience, Himanshu has helped 100+ students move from confusion to confidence in the stock market. His teaching philosophy blends the discipline of ancient wisdom with the precision of modern market strategy.</p>
            <Link to="/about" className="btn-gold" style={{ marginTop: '1.5rem', display: 'inline-block' }}>Know More</Link>
          </div>
          <div className="founder-right">
            <div className="quote-card">
              <div className="q-mark">"</div>
              <p className="q-text">Markets reward patience and knowledge. I built this platform to give you both — one lesson, one trade, one decision at a time.</p>
              <div className="q-author">— Himanshu Kumar</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA BAND */}
      <section className="cta-band">
        <div className="cta-inner">
          <h2 className="cta-title">Ready to start your market journey?</h2>
          <p className="cta-sub">Join 100+ students already learning with The Atharva Veda Equity</p>
          <div className="cta-btns">
            <Link to="/courses" className="btn-gold">View All Courses</Link>
            <Link to="/contact" className="btn-ghost">Talk to Us First</Link>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <div className="footer-inner">
          <div className="footer-brand">
            <div className="footer-logo">
              <img src="/monogram.svg" alt="AVE" style={{ width: '30px', height: '30px' }} />
              <span className="footer-brand-name">The Atharva Veda Equity</span>
            </div>
            <p className="footer-tagline">Wisdom-Driven Wealth</p>
          </div>
          <div className="footer-links">
            <Link to="/about">About</Link>
            <Link to="/courses">Courses</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/enquiry">Enrol Now</Link>
            <a href={AXIS_OPEN_ACCOUNT_URL} target="_blank" rel="noopener noreferrer">
              Open Demat Account
            </a>
          </div>
          <div className="footer-copy">© 2026 The Atharva Veda Equity. All rights reserved.</div>
        </div>
      </footer>

    </div>
  );
}

export default Home;